import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import Label from '../Label/index.js';
import { Typography } from '../Typography/typography.js';

const Radio = ({
  checked,
  className,
  defaultChecked,
  isDisabled,
  label,
  labelWeight = "normal",
  name,
  onChange,
  testSection,
  ...props
}) => {
  const labelClassNames = classNames("axiom-radio-label", {
    "cursor--pointer": true,
    "flush--bottom": true,
    "oui-label--disabled": isDisabled,
    "push--left": true,
    "weight--bold": labelWeight === "bold",
    "weight--light": labelWeight === "light",
    "weight--normal": labelWeight === "normal"
  });
  const inputWrapperClassNames = classNames(
    "axiom-radio-wrapper flex",
    typeof label === "string" ? "align-items-center" : "align-items-start"
  );
  const classes = classNames(
    "axiom-radio flex--none",
    typeof label !== "string" && "adjust-for-custom-label",
    className
  );
  return /* @__PURE__ */ jsx(Label, { testSection: `${testSection}-label`, children: /* @__PURE__ */ jsxs("div", { className: inputWrapperClassNames, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        checked,
        className: classes,
        "data-oui-component": true,
        "data-test-section": testSection,
        defaultChecked,
        disabled: isDisabled,
        name,
        onChange,
        type: "radio",
        ...props
      }
    ),
    /* @__PURE__ */ jsx(Typography, { className: labelClassNames, type: "body", children: label })
  ] }) });
};
Radio.displayName = "Radio";

export { Radio };
